module.exports = __webpack_public_path__ + "img/decorator-piano.b5adbff0.png";